import React from 'react';

import { bemCssModules } from '@utils';

import { ArrowRightIcon, PlusIcon } from './icons';

import style from './Icon.scss';

const cn = bemCssModules(style, 'Icon');

export type TIcon = {
  type: string;
};

const Icon: CustomFC<TIcon> = ({ className, type }) => {
  return (
    <div className={cn(null, [className])}>
      {['buy', 'deposit', 'referral', 'mobile_pay', 'receipt'].includes(type) ? (
        <PlusIcon />
      ) : (
        <ArrowRightIcon />
      )}
    </div>
  );
};

export default Icon;
